import React, { useCallback, useEffect, useState } from 'react'
import TimePicker from 'react-bootstrap-time-picker'

const toInt = (date) => {
  const items = date.split(':')
  return parseInt(items[0]) * 3600 + parseInt(items[1]) * 60
}

export default function TimeInputJS({
  defaultValue,
  minValue,
  maxValue,
  onChange,
  onEntered,
}) {
  const [value, setValue] = useState(defaultValue || '00:00')

  const handleChange = useCallback(
    (value) => {
      const hours = Math.floor(value / 3600)
      let hours_str = hours.toString()
      if (hours < 10) hours_str = '0' + hours_str

      const minutes = (value - hours * 3600) / 60
      let minutes_str = minutes.toString()
      if (minutes < 10) minutes_str = '0' + minutes_str

      const value_ = '' + hours_str + ':' + minutes_str

      setValue(value_)
      onChange(value_)
      if (onEntered) onEntered(value_)
    },
    [onChange, onEntered]
  )

  useEffect(() => {
    if (minValue) {
      if (toInt(minValue) > toInt(value)) {
        setValue(minValue)
        onChange(minValue)
        if (onEntered) onEntered(minValue)
      }
    }
  }, [minValue, value, onChange, onEntered])

  useEffect(() => {
    if (maxValue) {
      if (toInt(maxValue) < toInt(value)) {
        setValue(maxValue)
        onChange(maxValue)
        if (onEntered) onEntered(maxValue)
      }
    }
  }, [maxValue, value, onChange, onEntered])

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <TimePicker
      start={minValue}
      end={maxValue}
      value={value}
      format={24}
      step={30}
      style={{ maxWidth: '230px' }}
      onChange={handleChange}
    />
  )
}
